<template>
  <a-layout>
    <a-tabs v-model="currentTab" style="margin-top: -4px" @change="onTabChanged">
      <a-tab-pane key="caseTag" :tab="$t('tab.caseTag')" style="margin-top: -14px">
        <CaseTag ref="caseTag"/>
      </a-tab-pane>
      <a-tab-pane key="eachTag" :tab="$t('tab.eachTag')" forceRender style="margin-top: -14px">
        <EachTag ref="eachTag"/>
      </a-tab-pane>
      <a-tab-pane key="replenishTag" :tab="$t('tab.replenishTag')" forceRender style="margin-top: -14px">
        <ReplenishTag ref="replenishTag"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="print()">{{ $t('button.print') }}</a-button>
        <a-button type="primary" @click="getData()">{{ $t('button.query') }}</a-button>
        <vxe-input v-model="barcodeNo" :placeholder="$t('business.label.barcode')" class="query" @pressEnter="getData()" @search="getData()"/>
        <vxe-input v-model="pickingOrderNo" :placeholder="$t('business.label.pickingOrderNo')" class="query" @pressEnter="getData()" @search="getData()"/>
        <vxe-input v-model="wave" :placeholder="$t('placeholder.waveTag')" class="query" @pressEnter="getData()" @search="getData()"/>
        <vxe-input v-model="customerNo" :placeholder="$t('placeholder.customerNoTag')" class="query" @pressEnter="getData()" @search="getData()"/>
      </a-space>
    </a-tabs>
  </a-layout>
</template>
<script>
import CaseTag from '@/views/outbound/outBoundTag_Print/CaseTag.vue'
import EachTag from '@/views/outbound/outBoundTag_Print/EachTag.vue'
import ReplenishTag from '@/views/outbound/outBoundTag_Print/ReplenishTag.vue'

export default {
    name: 'OutBoundTagPrint',
    components: {
      CaseTag,
      EachTag,
      ReplenishTag
    },
    data() {
      return {
        currentTab: 'caseTag',
        barcodeNo: '',
        pickingOrderNo: '',
        wave: '',
        customerNo: ''
      }
    },
    methods: {
      onTabChanged(activeKey) {
        this.currentTab = activeKey
      },

      getData() {
        if (!this.barcodeNo && !this.customerNo && !this.pickingOrderNo && !this.wave) {
          return this.$warning({
            title: '请至少选择一个查询条件',
            centered: true,
            okText: '确定'
          })
        }
        if (this.currentTab === 'caseTag') {
          let body = {
            each: false,
            no: this.barcodeNo,
            'customer.no': this.customerNo,
            'pickingOrder.no': this.pickingOrderNo,
            wave: this.wave
          }
          this.$refs.caseTag.getData(body)

        } else if (this.currentTab === 'eachTag') {
          let body = {
            each: true,
            no: this.barcodeNo,
            'customer.no': this.customerNo,
            'pickingOrder.no': this.pickingOrderNo,
            wave: this.wave
          }
          this.$refs.eachTag.getData(body)
        } else if (this.currentTab === 'replenishTag') {
          let body = {
            replenish: true,
            no: this.barcodeNo,
            'customer.no': this.customerNo,
            'pickingOrder.no': this.pickingOrderNo,
            wave: this.wave
          }
          this.$refs.replenishTag.getData(body)
        }

      },
      print() {
        if (this.currentTab === 'caseTag') {
          this.$refs.caseTag.print()
        } else if (this.currentTab === 'eachTag') {
          this.$refs.eachTag.print()
        } else if (this.currentTab === 'replenishTag') {
          this.$refs.replenishTag.print()
        }

      }
    }
  }
</script>